module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("knqAy"))).then(() => parcelRequire('37nVf'));